// Tab filters in the address bar: param whitelists, merges and one guarded writer (hooks: use_query_mirror.js).
const UUID_RE = /^[A-Za-z0-9-]{1,64}$/;

const trimmed = (v) => (typeof v === 'string' ? v.trim() : '');

export const uuid_param = (v) => (UUID_RE.test(trimmed(v)) ? trimmed(v) : '');

export const enum_param = (v, allowed) => (allowed.indexOf(trimmed(v)) === -1 ? '' : trimmed(v));

// 'net|desc' -> { key: 'net', dir: 'desc' }; null unless both parts are whitelisted.
export const parse_sort = (v, keys, dirs) => {
  const parts = trimmed(v).split('|');
  return parts.length === 2 && keys.indexOf(parts[0]) !== -1 && dirs.indexOf(parts[1]) !== -1
    ? { key: parts[0], dir: parts[1] }
    : null;
};

// '' for the default order, so the default never reaches the URL.
export const sort_token = (sort, def) =>
  sort && sort.key && !(def && sort.key === def.key && sort.dir === def.dir)
    ? `${sort.key}|${sort.dir}`
    : '';

// The first present key wins: the new short key, then any legacy name still in old links.
export const first_param = (qs, keys) => {
  const k = keys.find((key) => qs.has(key));
  return k ? qs.get(k) : '';
};

// Rewrites only `keys` in place (null/undefined/'' drops the key; 0 is kept); every other param stays.
export const merge_query = (search, keys, values) => {
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  const v = values || {};
  keys.forEach((k) => {
    const x = v[k];
    if (x === undefined || x === null || x === '') qs.delete(k);
    else qs.set(k, String(x));
  });
  return qs.toString();
};

// Drops every owned key (legacy names too), then appends the truthy values; other params stay.
export const merge_search = (search, owned, values) => {
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  owned.forEach((k) => qs.delete(k));
  Object.keys(values).forEach((k) => {
    if (values[k]) qs.set(k, values[k]);
  });
  return qs.toString();
};

// Writes only while the live path is still `pathname`, so a later push (tab switch) is never overwritten.
export const replace_search = (history, pathname, build) => {
  const live = history.location;
  if (!live || live.pathname !== pathname) return false;
  const next = build(live.search || '');
  if ((live.search || '').replace(/^\?/, '') === next) return false;
  history.replace({ pathname: live.pathname, search: next ? `?${next}` : '' });
  return true;
};

// A linked teacher's display name: the URL carries only the uuid, so the name comes from a listed row.
export const linked_teacher_name = (rows, uuid) => {
  const row = uuid && Array.isArray(rows) ? rows.find((r) => r && r.teacher_uuid === uuid) : null;
  return row && row.teacher_name && row.teacher_name !== '—' ? row.teacher_name : '';
};

// What the teacher picker shows: the name, else a stand-in while a linked uuid's name is unknown.
export const LINKED_TEACHER_TEXT = 'Teacher from the link';
export const teacher_picker_text = (uuid, name) => name || (uuid ? LINKED_TEACHER_TEXT : '');
